import React from 'react';
import { ProjectCard } from '../../components';
import { projects } from '../../data';
import './ProjectsSection.css';

const ProjectsSection = ({ isVisible }) => {
  return (
    <section id="projects" className="projects-section">
      <div className="projects-container">
        <div className="projects-header">
          <p className="projects-label">Portfolio</p>
          <h2 className={`projects-title ${isVisible ? 'animate-slide-up' : 'opacity-0'}`}>
            Featured <span className="gradient-text">Projects</span>
          </h2>
        </div>
        
        <div className="projects-grid">
          {projects.map((project, index) => (
            <ProjectCard 
              key={index}
              project={project}
              isVisible={isVisible}
              animationDelay={index * 0.1}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
